// @core/api/endpoints/calendar/remove_calendar_member.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/calendar';

/**
 * Remove calendar member
 * Removes a member from the calendar, revoking their access. The member's events in the calendar are not deleted.
 */
export async function RemoveCalendarMember(
  calendar_id: string,
  member_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/calendars/:calendar_id/members/:member_id`;
  requestPath = requestPath.replace(':calendar_id', encodeURIComponent(calendar_id));
  requestPath = requestPath.replace(':member_id', encodeURIComponent(member_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
